import { axiosConsignadoInstance } from "../axiosInstance";
import { HistoricoErroPropostaResponseDTO, ProposalHistoryResponseDTO } from "./dto/proposal-history.dto";

export type ConsignadoRiskClassificationsProps = {
  page: number;
  pageSize: number;
}
export const getProposalHistoryByProposalId = async (
id:string): Promise<ProposalHistoryResponseDTO[]> => {
  try {
    const response = await axiosConsignadoInstance.get<ProposalHistoryResponseDTO[]>(`/api-consignado-trabalhador/v1/historico-proposta/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};

export const getNotificacoesTerceirosByProposalId = async (id: string): Promise<ProposalHistoryResponseDTO[]> => {
  const response = await axiosConsignadoInstance.get<ProposalHistoryResponseDTO[]>(`/api-consignado-trabalhador/v1/historico-proposta/${id}/notificacoes-terceiros`);
  return response.data;
};

export const getHistoricoErrosByProposalId = async (id: string): Promise<HistoricoErroPropostaResponseDTO[]> => {
  const response = await axiosConsignadoInstance.get<HistoricoErroPropostaResponseDTO[]>(`/api-consignado-trabalhador/v1/historico-proposta/${id}/erros`);
  return response.data;
};
